import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestdueDetailsAndDueDetailsBreakupReportsList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/reports/dueDetails`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/reports/dueDetails`, params);
  }
}

export function requestSdDueDetailsReportsList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/reports/securityDepositsDue`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/reports/securityDepositsDue`, params);
  }
}
